export default __webpack_public_path__ + "static/media/election2018general.32c155c2.txt";